import { useCallback } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Logger } from 'utilities';
import { ApiService } from '../../api';

const useGetCompanyUsers = (companyId: number | undefined, userSearchValue = '') => {
  const getCompanyUsers = useCallback(async () => {
    try {
      if (companyId) {
        return await ApiService.apiCompanyUsersRead(companyId.toString());
      }
    } catch (e) {
      Logger.error('An error occurred while retrieving company users', e);
      throw new Error('An error occurred while retrieving company users');
    }
  }, [companyId]);

  const { data, error, isLoading } = useQuery({
    enabled: !!companyId,
    queryKey: ['companyUsers', companyId],
    queryFn: getCompanyUsers,
    select: data => (data || []).filter(user => user.email?.includes(userSearchValue)),
  });

  return { data, error, isLoading, getCompanyUsers };
};

export default useGetCompanyUsers;

export const useGetFirmUsers = (firmId: number | undefined, userSearchValue: string) => {
  const getFirmUsers = useCallback(async () => {
    try {
      if (firmId) {
        return await ApiService.apiUsersList();
      }
    } catch (e) {
      Logger.error('An error occurred while retrieving firm users', e);
      throw new Error('An error occurred while retrieving firm users');
    }
  }, [firmId]);

  const { data, error, isLoading } = useQuery({
    enabled: !!firmId,
    queryKey: ['firmUsers', firmId],
    queryFn: getFirmUsers,
    select: data => (data || []).filter(user => user.email?.includes(userSearchValue)),
  });

  return { data, error, isLoading };
};
